const message = {
    company: "Company",
    department: "Department",
    directorate: "Directorate",
    division: "Division",
    employee: "Employee",
    functional: "Functional",
    grade: "Grade",
    jobStatus: "Job Status",    
    lookup: "Lookup",
    position: "Position",
    section: "Section",
    superior: "Approval (Superior)",
    unit: "OU (Unit)",
    user:"User",
    group: "Group",
    menu: "Menu",
    role: "Role",
    business: "Business",
    region: "Region",
    active: "Active",
    name6up: "Name (Grade 6Up)",
    fortable: "Fortable",
    rank: "Rank",
    birthdate: "Birth Date",
    workdate: "Work Begin",
    superior1: "Superior",
    nik_superior1: "NIK Superior",    
    superior2: "Head Superior",
    nik_superior2: "NIK Head Superior",    
    pic: "PIC Name",
    inactive_account: "This Account has been inactive",
    receive_notification: "Receive Notification",
    appraisal_year: "Appraisal Year",
    appraisal: "Appraisal",
    employee_data: "Employee Data",
    emp_name: "Employee Name",
    EPA: "Employee Performance Assessment",
    warning_letter_period: "Warning Letter (Effective)",
    appraisal_period: "Appraisal Period",
    comment_review: "Reviewer comments",
    company_name: "Company Name",
    company_desc: "Full Company Name",    
    dept_name: "Department Name",
    directorate_name: "Directorate Name",
    division_name: "Division Name",
    functional_name: "Functional Name",
    business_unit: "Business Unit",
    ou_name: "OU Name",
    region_code: "Region Code",
    period_History: "Period Year",
    cut_off: "Cut Off",
    valid_from: "Valid From",
    valid_to: "Valid To",
    semester: "Semester",   
    pembobotan: "On Rating",
    rating: "Rating",
    total_score: "Final Score",
    objective: "Objective and Indicator",
    achieve: "Achievement",
    evaluate: "Evaluation & Feedback",
    point: "Point",
    job_status_name: "Job Status Name",
    section_name: "Section Name",    
    position_name: "Position Name",
    s_edit: "Edit By Superior",
    s_date: "Edit Date Superior",    
    h_edit: "Edit By H. Superior",
    h_date: "Edit Date H. Superior",        
    company_all: "All Company",
    functional_all: "All Functional",
    grade_all: "All Grade",
    unit_all: "All Unit",    
    warning_letter: "SP (Warning Letter)",   
    status_sp: "SP Status",
    period_sp: "Period (SP Begin Date)",    
    appraisal_reset: "Appraisal Data (Appraisal Reset)",    
    input_by: "Input By (User)",
    input_date: "Date Input (User)",
    edit1_by: "Edit By (Superior)",
    edit1_date: "Edit Date (Superior)",
    edit2_by: "Edit By (Head Superior)",
    edit2_date: "Edit Date (Head Superior)",
    edit3_by: "Edit By (Komite)",
    edit3_date: "Edit Date (Komite)",  
    edit3_by: "Edit By (Komite)",
    edit3_date: "Edit Date (Komite)",
    edit4_by: "Edit By (Functional)",
    edit4_date: "Edit Date (Functional)",          
    emp_number: "ID Employee",
    code: "Code",
    description: "Description",    
    nik: "NIK",
    name: "Name",
    created_by: "Created By",
    created_date: "Created Date",
    edited_by: "Edited By",
    edited_date: "Edited Date",
    deleted_by: "Deleted By",
    deleted_date: "Deleted Date",    
    is_deleted: "Deleted",
    rate: "Final Rate",
    period: "Period",
    action: "Action",
    reset_confirmation: "Reset Confirmation",    
    promot_confirmation: "Confirmation of Promotion",
    review_confirmation: "Review Confirmation",    
    assesed_appraisal: "List of employees who have been assessed (Appraisal)",
    not_assesed_appraisal: "List of employees who have not been assessed (Appraisal)",
    changelog: "Changelog",
    email: "Email",
    username: "Username",
    full_name: "Name",
    account: "Account",
    is_required: "Value is required",
    year: "Year",
    create: "Create",
    password: "Password",
    log_history: "Assessment Activity Log (History)",
    lookup_group: "Lookup Group",
    lookup_key: "Lookup Key",
    lookup_value: "Lookup Value",
    lookup_info1: "Info 1",
    lookup_info2: "Info 2", 
    version: "Version",
    version_date: "Version Date",
    remark: "Remark",
    version_active: "Version Active",
    report_type: "Report Type",
    ChangeOnTransaction : "Change On Transaction ?",
    userExc: "User Exclusion",
    clear: "Clear",
    download_supporting_data: "Download Supporting Data",
    use_ad: "Use AD",
    create_appraisal_notice: "To create new appraisal data,",
    click_here: "Click here",
    criteria: "Criteria",   
    range: "Range",
    standard: "Standard",
    summary: "Summary",
    grade_begin: "Grade Begin",
    education: "Education",
    source: "Source",
    structure: "Structure Description",
    promotion_data: "Promotion Data",
    promotion_request: "Promotion Request",
    tolerance_up: "Tolerance Up",
    tolerance_down: "Tolerance Down",    
    promotion_status: "Promotion Request",    
    sync_confirmation: "Sync Confirmation",
    score: "Score",
    status: "Status",   
    lengthWork: "Length of Service",
    lengthGrade: "Grade Period",    
    requested_date: "Requested Date",
    requested_by: "Requested By",
    requester: "Requester",    
    hrr: "HRR/PGA Head",
    effective_date: "Effective Date",
    reason: "Reason",
    new_position: "New Position",
    reason_promot: "Reason Promotion",
    information: "Information",
    promotion: "Promotion",
    performance_period: "Periode Kinerja", 
    nik_length: "NIK must consist of at least 8 digits",    
    sap_result_success: "of the total employees synced successfully",
    sap_result_failed: "of the total employees failed to sync",    
    create_date: "Create Date",    
    dept_div_name: "Department & Division Name",    
    summary_rate: "Summary (Rate)",
    appraisal_type: "Appraisal Type",
    grade_type: "Grade Type",    
    org_unit: "Organization Unit",    
    disclaimer_promotion1: "The submission of promotions through the PES system remains recommendatory and will be verified by the respective Management Units.",
    disclaimer_promotion2: "It adheres to the qualification requirements outlined in the Company's promotion policy.",
    min2year: "Minimum 2 years",
    spminKP: "The SP data is collected during the current appraisal period",
    educationminKP: "Educational standards will be adjusted to the intended position",
    positionminKP: "Promotion requests are referred to the availability of positions",
    employee_type: "Employee Type",
    otp_msg: "Enter 6 Digit OTP",
    locked_score: "Display Confirmation",
    locked_score_msg: "This appraisal is locked and cannot be modified",
    remark_255: "Remarks (Max 255 Character)",
    remark_1000: "Remarks (Max 1000 Character)",    
    auth_report: "If you want to know the details of your data authorization, please",
    click_here: "click here!",
    action_role: "Action Role",
    promotbysuperior: "Promoted by Superior",
    emp_data: "Employee Data (Period)",
    display_confirm: "Display confirmation",
    role_change_msg: "The previous Action Role evaluation will remain in effect if there is a replacement Action Role.",
    change_confirm: "Are you sure want to change it ?",
    default_jobstatus: "The result has generate excluded PHK, Expatriate & Terminasi",    
    export_type: "Export Type",   
    trans_menu: "Transaction Menu",    
    committee: "Committee",
    assessed_by: "Assessed By",    
    approved_by: "Approved By",
    approved_date: "Approved Date",    
    rejected_by: "Rejected By",
    rejected_date: "Rejected Date",        
    signature_reviewee: "Signature of Reviewee",
    signature_reviewer: "Signature of Reviewer",
    name_and_date: "Name & Date",
    confirm_Save: "Sure about your answer ?",
    method_id: "ID",
    method_name: "Method Name",
    func_layer: "Functional Layer",
    func_Percent: "Functional (%)",
    method_func: "Method Functional",
    nik_functional: "NIK Functional",
    question_eng: "Question (EN)",
    question_ind: "Question (ID)",
    col_area: "Column Area",
    loop_total: "Loop Total",    
    question_procedure: "Question Procedure",    
    questions: "Questions",
    question_details : "Question Details",
    actions: "Actions",
    score_superior: "Score by Superior",
    rate_superior: "Rate by Superior",
    score_head_superior: "Score by Head Superior",
    rate_head_superior: "Rate by Head Superior",
    score_functional: "Score by Functional",
    rate_functional: "Rate by Functional",
    sub_rate : "Sub Rate",
    use_sub_range : "Use Sub Rate",

    message: {
        reset_confirmation: "Do you want to reset appraisal data",
        approve_confirmation: "Do you want to approve promotion data",
        reject_confirmation: "Do you want to reject promotion data",        
        sync_confirmation: "Are you sure ? These selected appraisal(s) data will be sync to HCM (max 100 data sent per batch).",
        sync_all_confirmation: "Are you sure to sync all appraisal data ?",        
        sync_no_data: "No data can be synced (HCM source and status are not the same as SYNC TO HCM)",
        sync_promot_confirmation: "Are you sure ? These promotion(s) data will be sync to Fiori (max 100 data sent per batch).",
        select_score: "Please Select the Assessment Score:",
        functional_not_assess: "Head Functional has not completed the review"
    },

    note: {
        history: "Note : Assessor data is sorted from bottom to top (the topmost data is the most recent data). Can be seen from the date and time in the column 'Input Date'",
        mydata: "Note : The green line is an employee whose evaluation has been assessed by the committee",
        listAssed: "Note for Admin Unit : For employee assessments that have been edited or uploaded by the Admin HO, there is no longer an edit button in the employee column",
        employee: "Note : Employees displayed are employees who are not in (PHK, Termination & Expatriate), join above or past 1-July-Year, and grade 10 i.e. director",
        reset: "Note : The data that is reset is the last assessment data !",
        last_reset: "Catatan : This reset will remove all assesment data !",        
        cancel_promot: "If you cancel this promotion request, you can still request it again at SAP Fiori",
        upload: " may be duplicated and new code may be entered. If the code already exists (duplicate), then the previous data will be updated",
        promote: "Note : Promotion requests that will be synced are promotion requests in the current year.",
        sync_hcm: "The assessment results that will be synced are the assessment results in the current year.",
        sp: "Note : The Warning Letters (SP) displayed are warning letter (SP) data issued during the current year's assessment",
        create_appraisal: "Note: If there is a Superior / Head Superior that is not suitable, please adjust it by changing before continuing with the assessment process."        
    }
}

export default message;